// ============================================================================
// SWAHILI TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Mkusanyiko wa mistari ya kutia moyo na marejeleo ya Strong

export const bibleVerses = [
  {
    reference: "Wafilipi 4:13",
    text: "Naweza kila kitu katika yeye anayenipa nguvu",
    version: "biblia_habari_njema",
    theme: "nguvu",
    strongNumbers: {
      "naweza": "G1411", // δύναμις (dynamis) = nguvu, uwezo
      "nguvu": "G1743" // ἐνδυναμόω (endynamoo) = kutia nguvu
    },
    context: "Paulo anazungumza juu ya uwezo wake wa kukabiliana na hali zote kwa sababu ya Kristo"
  },
  {
    reference: "Zaburi 23:1",
    text: "Bwana ni mchungaji wangu, sitapungukiwa na kitu",
    version: "biblia_habari_njema",
    theme: "ulinzi",
    strongNumbers: {
      "mchungaji": "H7462", // רָעָה (ra'ah) = kulisha, kulinda
      "sitapungukiwa": "H2637" // חָסֵר (chaser) = kupungukiwa, kuhitaji
    },
    context: "Daudi anaelezea imani yake kamili katika upatikanaji wa Mungu"
  },
  {
    reference: "Yohana 3:16",
    text: "Kwa maana Mungu aliupenda ulimwengu hivi, hata akamtoa Mwanawe pekee",
    version: "biblia_habari_njema",
    theme: "upendo",
    strongNumbers: {
      "aliupenda": "G25", // ἀγαπάω (agapao) = kupenda bila masharti
      "akamtoa": "G1325" // δίδωμι (didomi) = kutoa, kutolea
    },
    context: "Mstari maarufu zaidi kuhusu upendo wa Mungu kwa wanadamu"
  },
  {
    reference: "Wafilipi 4:7",
    text: "Na amani ya Mungu, inayozidi akili zote, italinda mioyo yenu",
    version: "biblia_habari_njema",
    theme: "amani",
    strongNumbers: {
      "amani": "G1515", // εἰρήνη (eirene) = amani, upatano
      "italinda": "G5432" // φρουρέω (phroureo) = kulinda, kuhifadhi
    },
    context: "Ahadi ya ulinzi wa Mungu kupitia amani ya ndani"
  },
  {
    reference: "Zaburi 119:105",
    text: "Neno lako ni taa kwa miguu yangu, na nuru kwa njia yangu",
    version: "biblia_habari_njema",
    theme: "uongozi",
    strongNumbers: {
      "taa": "H5216", // נִיר (niyr) = taa, mwanga
      "nuru": "H216" // אוֹר (or) = nuru, mwangaza
    },
    context: "Neno la Mungu kama kiongozi katika maisha ya kila siku"
  },
  {
    reference: "Mithali 3:5-6",
    text: "Mtegemee Bwana kwa moyo wako wote, wala usitegemee ufahamu wako mwenyewe",
    version: "biblia_habari_njema",
    theme: "imani",
    strongNumbers: {
      "mtegemee": "H982", // בָּטַח (batach) = kuwa na imani
      "moyo": "H3820" // לֵב (leb) = moyo, roho, nia
    },
    context: "Mwaliko wa kumwamini Mungu badala ya uwezo wetu wenyewe"
  },
  {
    reference: "Mathayo 5:14",
    text: "Ninyi ni nuru ya ulimwengu. Mji uliojengwa juu ya mlima hauwezi kufichwa",
    version: "biblia_habari_njema",
    theme: "ushuhuda",
    strongNumbers: {
      "nuru": "G5457", // φῶς (phos) = nuru, mwangaza wa kiroho
      "ulimwengu": "G2889" // κόσμος (kosmos) = ulimwengu, dunia
    },
    context: "Yesu anawahamasisha wanafunzi wake kuwa mashahidi ulimwenguni"
  }
];

export default bibleVerses;
